export enum SidebarItem {
  HOME = 'HOME',
  OPERATOR = 'OPERATOR',
  CONFIGURATION = 'CONFIGURATION',
  STREET = 'STREET',
  PARKING_ZONE = 'PARKING_ZONE',
  APARTMENT_COMPLEX = 'APARTMENT_COMPLEX',
  JOB = 'JOB',
  PARKING_LOT = 'PARKING_LOT',
  SUPPORTIVE_DOCUMENT = 'SUPPORTIVE_DOCUMENT',
  DOCUMENT_CATEGORY = 'DOCUMENT_CATEGORY',
  DOCUMENT = 'DOCUMENT',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SUBSCRIPTION_CAMPAIGN = 'SUBSCRIPTION_CAMPAIGN',
  USER_SUBSCRIPTION_REQUEST = 'USER_SUBSCRIPTION_REQUEST',
  USER_SUBSCRIPTION = 'USER_SUBSCRIPTION',
  USER = 'USER',
  BLOG_CATEGORY = 'BLOG_CATEGORY',
  BLOG_ARTICLE = 'BLOG_ARTICLE',
  BADGE = 'BADGE',
  SETTING = 'SETTING',
  WEBAPP = 'WEBAPP',
  DASHBOARD = 'DASHBOARD',
  REQUEST_PAYMENT = 'REQUEST_PAYMENT',
  SUBSCRIPTION_RENEWAL_EMAIL_TEST = 'SUBSCRIPTION_RENEWAL_EMAIL_TEST',
}
